export default __webpack_public_path__ + "static/features-link-icon1.url-bc55389d4795c8ff2c7a6a79eec012d5.svg";